(function () {
'use strict';

angular
.module('app.performanceReportLocalAreas')
.controller('performanceReportLocalAreasCtrl', 
    ['$scope', '$rootScope', 'measureService', 'performanceReportLocalAreasService', '$http', '$controller',
    function ($scope, $rootScope, measureService, performanceReportLocalAreasService, $http, $controller){
      var pieChartConfig = {
        options: {
          chart: {
            type: 'pie',
            zoomType: 'x',
            marginTop: 16
          },
          tooltip: {
            enabled: false
          },
          plotOptions: {
            pie: {
              allowPointSelect: false,
              cursor: 'pointer',
              dataLabels: {
                enabled: false
              },
              showInLegend: false
            }
          },
          credits: {
            enabled: false
          }
        },
        series: [{
          size: '80%',
          innerSize: '90%'
        }],
        title: {
          text: '',
          style: {
            fontSize: '16px',
            color: '#4B5567',
            fontFamily: 'ProximaNovaSemibold'
          }
        },
        xAxis: {
          type: 'datetime',
          title: {
            text: 'Date'
          }
        },
        noData: 'Pending Data...',
        loading: true
      };

      var pieChartConfigForPrint = {
        options: {
          chart: {
            type: 'pie',
            zoomType: 'x',
            marginTop: 22
          },
          tooltip: {
            enabled: false
          },
          plotOptions: {
            pie: {
              allowPointSelect: false,
              cursor: 'pointer',
              dataLabels: {
                enabled: false
              },
              showInLegend: false
            }
          },
          credits: {
            enabled: false
          }
        },
        series: [{
          size: '76%',
          innerSize: '90%'
        }],
        title: {
          text: '',
          y: 25,
          style: {
            fontSize: '22px',
            color: '#4B5567',
            fontFamily: 'ProximaNovaSemibold'
          }
        },
        xAxis: {
          type: 'datetime',
          title: {
            text: 'Date'
          }
        },
        noData: 'Pending Data...',
        loading: true
      };


        //Watch on change keyword / blog / project change

        $scope.$on('refreshDashboard', function(event, args) {
            getDataPerformanceReportLocalAreas();
        });

        function getDataPerformanceReportLocalAreas() {
            var params = $rootScope.saveParams;
            if(params == null || (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0)) {
              return;
            } 
            params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;

            getLocalAreasData(params);
        }

        function getLocalAreasData(params){
          performanceReportLocalAreasService.getLocalAreasData(params)
              .then(function(response){
                $scope.performanceLocalAreasData = response.localAreas;
                var selectedPerformanceKPI = null;
                angular.forEach($scope.performanceKPIList, function(performanceKPI){
                  if(performanceKPI.ticked == true){
                    selectedPerformanceKPI = performanceKPI.value;
                  }
                });
                if(selectedPerformanceKPI == null){
                  genLocalAreas(response.localAreas, $scope.performanceKPIList[0].value);
                } else{
                  genLocalAreas(response.localAreas, selectedPerformanceKPI);
                }
              })
              .catch(function(message){
                $scope.countries = [];
              })
              .finally(function(){
                $rootScope.$broadcast('sectionLoaded');
              })
        }

        function genLocalAreas(data, kpiName){
          $scope.countries = [];

          var country = {};
          var countryList = [];
          _.forEach(data.countries, function (item) {
            // chart
            country.pieChartConfig = angular.copy(pieChartConfig);
            country.pieChartConfig.series[0].name = item.name;
            country.pieChartConfig.title.text = item.name;
            // chart for print
            country.pieChartConfigForPrint = angular.copy(pieChartConfigForPrint);
            country.pieChartConfigForPrint.series[0].name = item.name;
            country.pieChartConfigForPrint.title.text = item.name;

            // name
            country.name = item.name;
            // bar
            country.progreeBar = _.get(item, 'progressBar');
            country.contentPieChart = _.get(item, 'contentPieChart.' + kpiName);
            if(kpiName == "reach"){
              country.pieChartConfig.series[0].data = [{color: country.contentPieChart.color, y: item.valuePieChart.reach_value}, {color: '#EEF2F4', y: (1-item.valuePieChart.reach_value)}];                

              //chart for print
              country.pieChartConfigForPrint.series[0].data = [{color: country.contentPieChart.color, y: item.valuePieChart.reach_value}, {color: '#EEF2F4', y: (1-item.valuePieChart.reach_value)}];                
            } else if(kpiName == "engagement"){
              country.pieChartConfig.series[0].data = [{color: country.contentPieChart.color, y: item.valuePieChart.engagement_value}, {color: '#EEF2F4', y: (1-item.valuePieChart.engagement_value)}];

              //chart for print
              country.pieChartConfigForPrint.series[0].data = [{color: country.contentPieChart.color, y: item.valuePieChart.engagement_value}, {color: '#EEF2F4', y: (1-item.valuePieChart.engagement_value)}];
            } else if(kpiName == "impression"){
              country.pieChartConfig.series[0].data = [{color: country.contentPieChart.color, y: item.valuePieChart.impression_value}, {color: '#EEF2F4', y: (1-item.valuePieChart.impression_value)}];

              //chart for print
              country.pieChartConfigForPrint.series[0].data = [{color: country.contentPieChart.color, y: item.valuePieChart.impression_value}, {color: '#EEF2F4', y: (1-item.valuePieChart.impression_value)}];
            }          
            if(angular.isNumber(country.contentPieChart.value)){
				      country.contentPieChart.value = country.contentPieChart.value;
            }            
            
            countryList.push(country);
            // $scope.countries.push(country);
            country = {};
          });

          // divide layout
          var i = 0;
          var layout = [];
          _.forEach(countryList, function (item) {
            i++;
            if (i % 4 === 0) {
              layout.push(item);
              $scope.countries.push(layout);
              layout = [];
              i = 0;
            } else {
              layout.push(item);
            }
            
          });
          if (layout.length != 0) {
            $scope.countries.push(layout);
          }
          // $scope.$broadcast('highchartsng.reflow');
        }      

        $scope.performanceLocalAreasData = null;
        $scope.performanceKPIList = [
          {label: 'Reach', value: "reach"},
          {label: 'Engagement', value: "engagement"},
          {label: 'Impression', value: "impression"}
        ];
        $scope.showPerformanceKPIList = function () {
          $scope.enablePerformanceKPIList = !$scope.enablePerformanceKPIList;
        }

        $scope.$watch('selectedPerformanceKPI', function(newValue, oldValue){
          if(newValue !== oldValue && newValue !== undefined && newValue.length != 0){         
            genLocalAreas($scope.performanceLocalAreasData, newValue[0].value);
          }
        });

        // first initiating
        getDataPerformanceReportLocalAreas();
    }]);
})();